import React, { useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import OneZappRoutes from "./routes/routes";
import Footer from "./components/shared/Footer";
import Header from "./components/shared/Header";
import { CookiesPopup } from "./components/dialogs/CookiesPopup";
import { PromoDialog } from "./components/dialogs/PromoDialog";
import ReactGA from "react-ga4";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/style.css";
import "./assets/css/styles.min.css";
import "./assets/css/fonts.css";
import { SOCAnnouncementDialog } from "./components/dialogs/SOCAnnouncementDialog";
import { CookiesProvider } from "react-cookie";

function AppLayout() {
  ReactGA.initialize("G-Q8HQ99H3W0");
  return (
    <>
      <CookiesProvider defaultSetOptions={{ path: "/" }}>
        <Router>
          <Toaster
            position="top-center"
            reverseOrder={false}
            toastOptions={{
              className: "",
              duration: 3000,
              style: {
                background: "#91298c",
                color: "#fff",
              },
            }}
          />
          <Header />
          <OneZappRoutes />
          <Footer />
          <SOCAnnouncementDialog />
          <CookiesPopup />
          <PromoDialog />
        </Router>
      </CookiesProvider>
    </>
  );
}

export default AppLayout;
